import { createTheme } from '@material-ui/core/styles';
import { theme as nimble } from './theme-vars';

const pxToNumber = value => parseInt(String(value), 10) || 0;

export const muiTheme = createTheme({
  palette: {
    primary: { main: nimble.colours.nimbleRed },
    secondary: { main: nimble.colours.green },
    error: { main: nimble.colours.red },
    success: { main: nimble.colours.green },
    text: {
      primary: nimble.colours.black,
      secondary: nimble.colours.neutralText
    },
    background: { default: nimble.colours.white }
  },
  typography: {
    fontFamily: nimble.font.nimbleFont,
    h1: {
      fontFamily: nimble.font.nimbleHeadingFont,
      fontSize: nimble.size.xxgiant
    },
    h2: {
      fontFamily: nimble.font.nimbleHeadingFont,
      fontSize: nimble.size.xgiant
    },
    h3: {
      fontFamily: nimble.font.nimbleHeadingFont,
      fontSize: nimble.size.giant
    },
    h4: {
      fontFamily: nimble.font.nimbleHeadingFont,
      fontSize: nimble.size.xxlarge
    },
    h5: {
      fontFamily: nimble.font.nimbleHeadingFont,
      fontSize: nimble.size.xlarge
    },
    h6: {
      fontFamily: nimble.font.nimbleHeadingFont,
      fontSize: nimble.size.large
    },
    button: {
      textTransform: 'none',
      fontWeight: 600
    }
  },
  overrides: {
    MuiButton: {
      sizeLarge: {
        fontSize: '1rem',
        lineHeight: '1.5rem',
        padding: '11px 40px'
      }
    }
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: pxToNumber(nimble.breakpoints.min.sm),
      md: pxToNumber(nimble.breakpoints.min.md),
      lg: pxToNumber(nimble.breakpoints.min.lg),
      xl: pxToNumber(nimble.breakpoints.min.xl)
    }
  },
  shape: {
    borderRadius: pxToNumber(nimble.misc.buttonRadius) || 4
  }
});
